import { render } from "./search-filter-aptitude-test.vue?vue&type=template&id=0140c567&scoped=true"
import script from "./search-filter-aptitude-test.vue?vue&type=script&lang=js"
export * from "./search-filter-aptitude-test.vue?vue&type=script&lang=js"

import "./search-filter-aptitude-test.vue?vue&type=style&index=0&id=0140c567&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0140c567"]])

export default __exports__